import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=aa9c108c&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9c108c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JienaLiu\\Documents\\bookingEngine\\BookingEngineFrontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa9c108c')) {
      api.createRecord('aa9c108c', component.options)
    } else {
      api.reload('aa9c108c', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=aa9c108c&scoped=true", function () {
      api.rerender('aa9c108c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Login.vue"
export default component.exports